import React from 'react';

import { Typography } from '@mui/material';
import { AlineButton } from 'src/components';
import { SuccessTickSmallIcon } from 'src/components/icons/Success';
import { homePageRoute } from 'src/config';
import { openLink } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  helpText: {
    fontSize: 20,
    fontWeight: 700,
  },
  infoActionSection: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  infoList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    margin: 0,
    padding: theme.spacing(1),
  },
  infoListIcon: {
    [theme.breakpoints.down('sm')]: {
      flexShrink: 0,
      height: 19,
      width: 17,
    },
  },
  infoListItem: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1.25),
  },
  infoListItemText: {
    fontSize: 14,
  },
  infoListSection: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  infoSection: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(5),
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
  },
  learnMoreButton: {
    borderRadius: 24,
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.75, 3),
      width: '100%',
    },
  },
}));

export function AboutAline() {
  const { classes } = useStyles();

  return (
    <div className={classes.infoSection}>
      <div className={classes.infoListSection}>
        <Typography className={classes.helpText}>
          Get started with a trial of Aline today and:
        </Typography>
        <div className={classes.infoList}>
          {[
            'Use Aline AI powered by GPT, Claude, and Gemini to smartly negotiate your contracts.',
            'Save your team countless hours using templates and workflows.',
            'Electronically sign any document using AlineSign.',
          ].map((string, i) => {
            return (
              <div key={i} className={classes.infoListItem}>
                <SuccessTickSmallIcon className={classes.infoListIcon} />
                <Typography className={classes.infoListItemText}>{string}</Typography>
              </div>
            );
          })}
        </div>
      </div>
      <div className={classes.infoActionSection}>
        <AlineButton
          buttonClassName={classes.learnMoreButton}
          color="primary"
          variant="contained"
          onClick={() => openLink(homePageRoute)}
        >
          Get Started
        </AlineButton>
      </div>
    </div>
  );
}
